import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routePaymentTermsTemplateCreate,
  detail: routePaymentTermsTemplateDetail,
  home: routePaymentTermsTemplatesHome,
  root: routePaymentTermsTemplatesRoot,
} = createDoctypeRoutes({
  createName: 'new-payment-terms-template',
  createPath: 'new-payment-terms-template',
  detailName: 'paymentTermsTemplateDetail',
  doctype: DOCTYPES.PAYMENT_TERMS_TEMPLATE,
  homeName: 'payment-terms-templates-home',
  path: 'payment-term-template',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/paymentTermsTemplates/AddPaymentTermsTemplate.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/paymentTermsTemplates/ViewPaymentTermsTemplate.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/accounting/ViewAccountingSettings.vue'),
  },
})

export {
  routePaymentTermsTemplateCreate,
  routePaymentTermsTemplateDetail,
  routePaymentTermsTemplatesHome,
  routePaymentTermsTemplatesRoot,
}
